import { type FC } from "react";
import * as styles from "./styles.css";

// 削除予定のコンポーネントです。
// デザイン上の理由がない場合、
// app/packs/shared/components/Tableディレクトリ直下のものを使用してください。

type Props = {
  /** テーブルの内容 */
  children?: React.ReactNode;
  /** コンポーネントに適用するクラス名 */
  className?: string;
  elementRef?: React.RefObject<HTMLTableElement>;
};

export const Table: FC<Props> = ({ children, className, elementRef }) => (
  <table
    className={`
      ${styles.table}
      ${className || ""}
    `}
    ref={elementRef}
  >
    <tbody>{children}</tbody>
  </table>
);
